<template>
  <svg
    :class="customClass"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <path d="M16 17l5-5-5-5" />
    <path d="M21 12H9" />
  </svg>
</template>

<script>
export default {
  name: "ExitIcon",
  props: {
    customClass: {
      type: String,
      default: "w-6 h-6",
    },
  },
};
</script>
